import React from 'react';
import healthCompassLogo from '/icons/logos/health-compass.svg';

const SystemMaintenance = () => {
  return (
    <div className="flex items-center justify-center min-h-screen p-4 sm:p-8 md:p-10 2xl:p-14 bg-[#e9e9e9]">
      <div className="w-full min-h-[calc(100vh-2rem)] sm:min-h-[calc(100vh-4rem)] md:min-h-[calc(100vh-5rem)] 2xl:min-h-[calc(100vh-7rem)] bg-[#ececec] border border-gray-200 rounded-[30px] md:rounded-[45px] flex flex-col items-center justify-center px-6 sm:px-10 2xl:px-16">
        <img
          src={healthCompassLogo}
          alt="healthcompass Rx"
          className="mb-10"
        />
        <h1 className="text-[22px] sm:text-[34px] font-semibold text-center mb-6 text-gray-800 leading-tight">
          System Maintenance in Progress
        </h1>
        <p className="text-center text-[16px] sm:text-[21px] md:text-[26px] text-gray-800 mb-6 leading-tight">
          REEL Outline is temporarily unavailable during maintenance.<br />
          Thank you for your patience.
        </p>
        <p className="text-center text-[13px] sm:text-[16px] md:text-[20px] text-gray-700">
          For any questions, please contact us at support@realoutline.com
        </p>
      </div>
    </div>
  );
};

export default SystemMaintenance;